const STORAGE_KEY = "sidebar-width";
const WIDTH_CHANGE_EVENT = "df:sidebar-width-change";
const WRAPPER_SELECTOR = '[data-slot="sidebar-wrapper"]';

export const SIDEBAR_MIN_WIDTH = 200;
export const SIDEBAR_MAX_WIDTH = 800;
export const SIDEBAR_DEFAULT_WIDTH = 256;

export function clampSidebarWidth(width: number) {
  return Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_MIN_WIDTH, Math.round(width)));
}

export function readSavedSidebarWidth() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) return SIDEBAR_DEFAULT_WIDTH;
    const parsed = Number.parseInt(saved, 10);
    if (Number.isNaN(parsed)) return SIDEBAR_DEFAULT_WIDTH;
    return clampSidebarWidth(parsed);
  } catch {
    return SIDEBAR_DEFAULT_WIDTH;
  }
}

export function saveSidebarWidth(width: number) {
  const clamped = clampSidebarWidth(width);
  try {
    localStorage.setItem(STORAGE_KEY, String(clamped));
  } catch {
    // localStorage unavailable
  }
}

export function applySidebarWidth(width: number) {
  const clamped = clampSidebarWidth(width);
  const wrapper = document.querySelector<HTMLElement>(WRAPPER_SELECTOR);
  if (!wrapper) return clamped;
  wrapper.style.setProperty("--sidebar-width", `${clamped}px`);
  return clamped;
}

export function getCurrentSidebarWidth() {
  const wrapper = document.querySelector<HTMLElement>(WRAPPER_SELECTOR);
  if (!wrapper) return readSavedSidebarWidth();
  const raw = getComputedStyle(wrapper).getPropertyValue("--sidebar-width").trim();
  if (!raw) return readSavedSidebarWidth();
  const parsed = Number.parseInt(raw.replace("px", ""), 10);
  if (Number.isNaN(parsed)) return readSavedSidebarWidth();
  return clampSidebarWidth(parsed);
}

export function emitSidebarWidthChange(width: number) {
  window.dispatchEvent(
    new CustomEvent<number>(WIDTH_CHANGE_EVENT, {
      detail: clampSidebarWidth(width),
    })
  );
}

export function subscribeSidebarWidthChange(handler: (width: number) => void) {
  const listener = (event: Event) => {
    const custom = event as CustomEvent<number>;
    handler(clampSidebarWidth(custom.detail));
  };
  window.addEventListener(WIDTH_CHANGE_EVENT, listener as EventListener);
  return () => window.removeEventListener(WIDTH_CHANGE_EVENT, listener as EventListener);
}
